import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const AIProfileSuggestionsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-100 overflow-hidden h-full p-6 relative" data-id="element-668">
      <div className="relative z-10 flex flex-col h-full" data-id="element-669">
        <div className="flex items-center mb-6" data-id="element-670">
          <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 p-[2px]" style={{
          background: 'linear-gradient(135deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)'
        }} data-id="element-671">
            <div className="w-full h-full rounded-full flex items-center justify-center bg-white p-1.5" data-id="element-672">
              <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="GB Intelligence" className="w-3.5 h-3.5 object-contain" data-id="element-673" />
            </div>
          </div>
          <div data-id="element-674">
            <h2 className="text-base font-normal text-gray-900" data-id="element-675">
              GB Intelligence
            </h2>
            <p className="text-xs text-gray-500 font-normal" data-id="element-676">
              Suggerimenti Personalizzati
            </p>
          </div>
        </div>

        <div className="space-y-3 flex-1" data-id="element-677">
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-100 hover:border-green-600 transition-colors cursor-pointer group" data-id="element-678">
            <h3 className="text-sm font-normal text-gray-900 mb-1 group-hover:text-green-600 transition-colors" data-id="element-679">
              Completa il tuo profilo
            </h3>
            <p className="text-xs text-gray-600 font-normal mb-2 leading-relaxed" data-id="element-680">
              Aggiungi i tuoi interessi per ricevere suggerimenti più
              pertinenti.
            </p>
            <div className="flex items-center text-xs text-green-600 font-normal" data-id="element-681">
              <span data-id="element-682">Aggiorna ora</span>
              <ArrowRightIcon size={12} className="ml-1" strokeWidth={1.5} data-id="element-683" />
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 border border-gray-100 hover:border-green-600 transition-colors cursor-pointer group" data-id="element-684">
            <h3 className="text-sm font-normal text-gray-900 mb-1 group-hover:text-green-600 transition-colors" data-id="element-685">
              Partecipa al prossimo evento
            </h3>
            <p className="text-xs text-gray-600 font-normal mb-2 leading-relaxed" data-id="element-686">
              "Il futuro dell'ESG" è molto rilevante per i tuoi interessi.
            </p>
            <div className="flex items-center text-xs text-green-600 font-normal" data-id="element-687">
              <span data-id="element-688">Scopri di più</span>
              <ArrowRightIcon size={12} className="ml-1" strokeWidth={1.5} data-id="element-689" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AIProfileSuggestionsWidget;